import React from "react";
import PropTypes from "prop-types";

import { Field } from "formik";

export default function InputField({
  name,
  label,
  type = "text",
  size = "s12 m6 l6",
  children,
  ...props
}) {
  const htmlId = `field_${name}`;
  return (
    <div className={`col input-field ${size}`}>
      <Field id={htmlId} name={name} type={type} {...props} />
      <label htmlFor={htmlId}>{label}</label>
      {children}
    </div>
  );
}

InputField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
  size: PropTypes.string,
  children: PropTypes.node,
};
